import { Mark, mergeAttributes } from '@tiptap/core'

export default Mark.create({
  name: 'cta',

  priority: 1100,

  inclusive: false,

  defaultOptions: {
    HTMLAttributes: {
      target: '_self',
      'data-cta': 'primary',
    },
  },

  addAttributes() {
    return {
      'data-cta': {
        default: 'primary',
      },
      href: {
        default: null,
      },
      target: {
        default: this.options.HTMLAttributes.target,
      },
    }
  },

  parseHTML() {
    return [{ tag: 'a[data-cta]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['a', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },

  addCommands() {
    return {
      setCta: attributes => ({ commands }) => {
        return commands.setMark('cta', attributes)
      },
      toggleCta: attributes => ({ commands }) => {
        return commands.toggleMark('cta', attributes)
      },
      unsetCta: () => ({ commands }) => {
        return commands.unsetMark('cta')
      },
    }
  },
})
